// 订单列表
import request from '@/utils/request.js'
import qs from 'qs'

// 订单已处理列表 + 筛选功能
export const OrderList = (page, category, cancelToken) => {
  return request({
    method: 'get',
    url: `/zzzx/getorder/${page}/${category || ''}`,
    cancelToken
  })
}

// 订单未处理 + 筛选功能
export const UnprocessedOrder = (page, category, cancelToken) => {
  return request({
    method: 'get',
    url: `/zzzx/getunorder/${page}/${category || ''}`,
    cancelToken
  })
}

// 查看订单详情
export const ViewOrderDetails = (id) => {
  return request({
    method: 'get',
    url: `/zzzx/findorderinfo/${id}`
  })
}

// 订单对接
export const docking = (id) => {
  return request({
    method: 'get',
    url: `/zzzx/confirmdocked/${id}`
  })
}

// 订单修改
export const orderModify = (data) => {
  return request({
    method: 'post',
    url: '/zzzx/ordermodify',
    data: qs.stringify(data)
  })
}
